import { Box, Spinner, Text } from "@chakra-ui/react";
import React, { useEffect } from "react";
import { useBeforeunload } from "react-beforeunload";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import Layout from "../../../components/dashboard/Layout";
import EditTemplateForm from "../../../containers/admin/whatsapp-templates/EditTemplateForm";
import {
  getWhatsappTemplateRequest,
  selectWhatsappTemplate,
} from "../../../modules/admin-modules/whatsapp-templates/Actions";

const EditWhatsappTemplate = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { name } = useParams();
  const decodedName = name ? decodeURIComponent(name) : "";

  const user = useSelector((state) => state.user.userData);
  const userLoading = useSelector((state) => state.user.isLoading);
  const loading = useSelector((state) => state.whatsappTemplates.loading);
  const selected = useSelector((state) => state.whatsappTemplates.selected);
  const list = useSelector((state) => state.whatsappTemplates.list);
  const dirty = useSelector((state) => state.whatsappTemplates.dirty);
  const error = useSelector((state) => state.whatsappTemplates.error);

  const isSuperAdmin =
    user?.role &&
    Array.isArray(user.role) &&
    user.role.some((role) => role?.name === "Super Admin");

  useBeforeunload((event) => {
    if (dirty) {
      event.preventDefault();
    }
  });

  useEffect(() => {
    if (userLoading) return;

    if (user?.role && Array.isArray(user.role)) {
      if (!isSuperAdmin) {
        navigate("/dashboard/students");
      }
    }
  }, [user, userLoading, isSuperAdmin, navigate]);

  useEffect(() => {
    if (!decodedName || !isSuperAdmin) return;
    if (selected?.name === decodedName) return;

    const fromList = Array.isArray(list)
      ? list.find((item) => item?.name === decodedName)
      : null;

    if (fromList) {
      dispatch(selectWhatsappTemplate(fromList));
      return;
    }

    dispatch(getWhatsappTemplateRequest(decodedName));
  }, [decodedName, isSuperAdmin, list, selected?.name, dispatch]);

  if (userLoading || !user?.role || !isSuperAdmin) {
    return null;
  }

  return (
    <Layout>
      {loading && !selected ? (
        <Box px={8} py={10}>
          <Spinner color="brand.primary" />
        </Box>
      ) : selected?.name === decodedName ? (
        <EditTemplateForm
          onBack={() => navigate("/dashboard/whatsapp-templates")}
        />
      ) : (
        <Box px={8} py={10}>
          <Text color="var(--text-muted)">
            {error || "Template not found."}
          </Text>
        </Box>
      )}
    </Layout>
  );
};

export default EditWhatsappTemplate;
